import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=ae4bb81e&scoped=true&"
import script from "./NewFooter.vue?vue&type=script&lang=js&"
export * from "./NewFooter.vue?vue&type=script&lang=js&"
import style0 from "./NewFooter.vue?vue&type=style&index=0&id=ae4bb81e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4bb81e",
  null
  
)

export default component.exports